import { getExt } from 'pano-utils';
import axios from 'axios';
import { LibApiType, QiniuTokenType } from '@types';
import { $member } from '@stores/memberStores';
import { getAudioLength } from '@utils/getAudioLength';
import getFileMd5 from '@utils/getFileMd5';
import uploadToQiniu from '@utils/uploadToQiniu';
import addToLib from '../actions/addToLib';
import { baseSpaceCheck, remainSpaceCheck } from '../actions/spaceCheck';

interface VoiceToLibParams {
  name: string;
  url: string;
  albumId?: number;
  subtitle?: string;
}

/** 下载文件并添加到素材库 */
const voiceToLib = async ({
  name,
  url,
  albumId = 0,
  subtitle = '',
}: VoiceToLibParams): Promise<number> => {
  // 下载数据并转换为 File 对象
  await baseSpaceCheck();
  const { data } = await axios.get(url, { responseType: 'blob' });
  await remainSpaceCheck(data.size);
  const metadata = { type: data.type ?? 'audio/mpeg' };

  const file = new File([data], `${name}.mp3`, metadata);

  // 参数拼接
  const { uid } = $member.getState().property!;
  const prefix = `/${uid}/${LibApiType.audio}`;
  const duration = await getAudioLength(file);
  const md5 = await getFileMd5(file);
  const key = `${prefix}/${md5}.${getExt(file.name)}`;

  // 上传到七牛
  const qiniuUrl = await uploadToQiniu({
    tokenType: QiniuTokenType.media,
    file,
    key,
  });

  // 添加到素材库
  return addToLib({
    type: LibApiType.audio,
    url: qiniuUrl,
    size: file.size,
    name: file.name,
    duration: Math.ceil(duration),
    albumId,
    subtitle,
  });
};

export default voiceToLib;
